export default "__VITE_ASSET__BZx1y5Li__"